import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http"; // Import HttpClientModule
import { FormsModule } from "@angular/forms"; // Import FormsModule for ngModel
import { LoginComponent } from "./login/login.component";
import { StoryComponent } from "./story/story.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatPaginatorModule } from '@angular/material/paginator';
import { InterceptorModule } from "./interceptor/interceptor.module";
import { MatTableModule } from "@angular/material/table";
import { MatExpansionModule } from "@angular/material/expansion";
import { AppTZPipeModule } from "./date-format.pipe";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { NgOtpInputModule } from "ng-otp-input";
import { ReactiveFormsModule } from "@angular/forms";
import { LoadingBarModule } from "@ngx-loading-bar/core";
import { WorkspaceComponent } from "./workspace/workspace.component";
import { CreateApikeyComponent } from "./create-apikey/create-apikey.component";
import { ViewWorkspaceComponent } from "./view-workspace/view-workspace.component";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { UsersComponent } from "./users/users.component";
import { AddUserComponent } from "./add-user/add-user.component";
import { MemoriesComponent } from "./memories/memories.component";
import { RecipeComponent } from "./recipe/recipe.component";
import { ReceiptComponent } from "./receipt/receipt.component";
import { NutritionComponent } from "./nutrition/nutrition.component";
import { InteractionsComponent } from "./interactions/interactions.component";
import { RemindersComponent } from "./reminders/reminders.component";
import { SubscriptionComponent } from "./subscription/subscription.component";
import { ApiAuditsComponent } from "./api-audits/api-audits.component";
import { ReadMeComponent } from "./read-me/read-me.component";
import { QuickstartComponent } from "./quickstart/quickstart.component";
import { UsageComponent } from "./usage/usage.component";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatStepperModule } from "@angular/material/stepper";
import {
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';
import { SiteNavComponent } from './site-nav/site-nav.component';
import { ConnectHeroComponent } from './connect-apps/connect-hero.component';
import { LabComponent } from "./lab/lab.component";
import { PaymentsComponent } from "./payments/payments.component";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { TermsOfUseComponent } from "./terms-of-use/terms-of-use.component";
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { ChatComponent } from './chat/chat.component';
import { McpConfigDialogComponent } from "./chat/mcp-config-dialog/mcp-config-dialog.component";
import { SharedWorkspacesComponent } from './shared-workspaces/shared-workspaces.component';
import { SharedWorkspaceDetailComponent } from './shared-workspace-detail/shared-workspace-detail.component';
import { AcceptInviteComponent } from './accept-invite/accept-invite.component';
import { MemoryCardComponent } from './shared-cards/memory-card.component';
import { RecipeCardComponent } from './shared-cards/recipe-card.component';
import { ShareToWorkspaceDialogComponent } from './share-to-workspace/share-to-workspace-dialog.component';

import { DeviceFingerprintService } from './services/device-fingerprint.service';
import { FingerprintInterceptor } from './interceptor/fingerprint.interceptor';

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    StoryComponent,
    WorkspaceComponent,
    UsersComponent,
    CreateApikeyComponent,
    AddUserComponent,
    ViewWorkspaceComponent,
    MemoriesComponent,
    RecipeComponent,
    ReceiptComponent,
    NutritionComponent,
    InteractionsComponent,
    RemindersComponent,
    SubscriptionComponent,
    ApiAuditsComponent,
    ReadMeComponent,
    QuickstartComponent,
    UsageComponent,
    LabComponent,
    PaymentsComponent,
    TermsOfUseComponent,
    PrivacyPolicyComponent,
    UserDashboardComponent,
    ChatComponent,
    McpConfigDialogComponent,
    SharedWorkspacesComponent,
    SharedWorkspaceDetailComponent,
    AcceptInviteComponent,
    MemoryCardComponent,
    RecipeCardComponent,
    ShareToWorkspaceDialogComponent
  ],
  imports: [
    SiteNavComponent,
    ConnectHeroComponent,
    BrowserModule,
    AppRoutingModule,
    MatSidenavModule,
    MatButtonModule,
    MatDialogModule,
    CommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatDatepickerModule,
    HttpClientModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTabsModule,
    ToastrModule.forRoot(),
    InterceptorModule,
    MatTableModule,
    MatExpansionModule,
    AppTZPipeModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatListModule,
    MatTabsModule,
    NgOtpInputModule,
    ReactiveFormsModule,
    LoadingBarModule,
    MatProgressBarModule,
    MatSelectModule,
    MatGridListModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatCheckboxModule
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }